export default function getVoicemailDialerLock(promise) {
  if (!window.navigator.locks) {
    console.warn("Web Lock API is not available");
    return new Promise(resolve => {
      resolve({});
      return promise;
    });
  }
  const controller = new AbortController();
  const lockOptions = {
    signal: controller.signal
  };
  return new Promise((resolve, reject) => {
    try {
      // If the lock isn't acquired within one second, then abort it
      setTimeout(() => {
        controller.abort();
        reject(
          "Couldn't grant access to Voicemail AutoDialer, is it already running in another tab/window?"
        );
      }, 1000);
      navigator.locks.request("voicemail-autodialer", lockOptions, lock => {
        resolve(lock);
        return promise;
      }).catch(() => {});
    } catch (error) {
      reject(error);
    }
  });
}

export async function checkVoicemailDialerLockAvailable() {
  if (!window.navigator.locks) {
    return true;
  }

  try {
    const state = await navigator.locks.query();
    const isLocked = state.held.some(lock => lock.name === "voicemail-autodialer");
    return !isLocked;
  } catch (error) {
    return true;
  }
}
